Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _withBrand = require('../themes/withBrand');

var _withBrand2 = _interopRequireDefault(_withBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FLAGS = ['info', 'danger', 'warning'];
var flagValidator = _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(undefined, FLAGS);

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _textlike2['default'].isRequired,
  book: _propTypes2['default'].bool,
  brand: _withBrand.requiredBrandPropType,
  secondary: _propTypes2['default'].bool
}, FLAGS.reduce(function (obj, flag) {
  return Object.assign({}, obj, _defineProperty({}, flag, flagValidator));
}, {})));

var defaultProps = {
  children: undefined,
  info: false,
  danger: false,
  warning: false,
  secondary: false,
  book: false
};

function StatusLabel(_ref) {
  var css = _ref.css,
      children = _ref.children,
      styles = _ref.styles,
      info = _ref.info,
      danger = _ref.danger,
      warning = _ref.warning,
      secondary = _ref.secondary,
      book = _ref.book,
      brand = _ref.brand;

  var additionalStyles = Object.assign({}, info && styles.info, danger && styles.danger, warning && styles.warning);

  var isSelectBrand = brand === _withBrand.BRAND_SELECT;

  return _react2['default'].createElement(
    'div',
    css(styles.container),
    (info || danger || warning) && _react2['default'].createElement('div', css(styles.leftColorBar, additionalStyles)),
    _react2['default'].createElement(
      'div',
      css(styles.content, secondary && styles.content_secondary, isSelectBrand && styles.content_select, book && styles.content_book, (info || danger || warning) && styles.content_hasColorBar),
      children
    )
  );
}

StatusLabel.componentCategory = 'Core';
StatusLabel.displayName = 'StatusLabel';
StatusLabel.propTypes = propTypes;
StatusLabel.defaultProps = defaultProps;

exports['default'] = (0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref2) {
  var unit = _ref2.unit,
      color = _ref2.color,
      font = _ref2.font;
  return {
    container: {
      display: 'inline-block',
      marginRight: 4,
      verticalAlign: 'middle'
    },

    content: Object.assign({}, font.textMicro, font.bold, {
      display: 'table-cell',
      backgroundColor: color.white,
      border: '1px solid ' + String(color.accent.lightGray),
      borderRadius: 2,
      padding: '3px ' + unit * 0.75 + 'px'
    }),

    content_secondary: {
      border: '1px solid ' + String(color.accent.bgGray),
      backgroundColor: color.accent.bgGray
    },

    content_select: {
      color: color.core.hackberry,
      border: '1px solid ' + String(color.core.hackberry),
      backgroundColor: color.white
    },

    content_book: Object.assign({}, font.book),

    content_hasColorBar: {
      borderLeft: 'none',
      borderRadius: '0 2px 2px 0'
    },

    leftColorBar: {
      display: 'table-cell',
      borderRadius: '2px 0 0 2px',
      border: '1px solid ' + String(color.accent.lightGray),
      borderRight: 'none',
      height: '100%',
      width: 0.5 * unit,
      verticalAlign: 'top'
    },

    info: {
      backgroundColor: color.core.babu,
      border: '1px solid ' + String(color.core.babu)
    },

    danger: {
      backgroundColor: color.core.arches,
      border: '1px solid ' + String(color.core.arches)
    },

    warning: {
      backgroundColor: color.accent.beach,
      border: '1px solid ' + String(color.accent.beach)
    }

  };
}, { pureComponent: true })(StatusLabel));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/StatusLabel.js
// module id = 144
// module chunks = 923280921217 19843951674672